// extracted by mini-css-extract-plugin
export default {"item":"Nk1V9EhO","columns":"RVNDsxJ1"};